/**
 * Account picker shown at the top of a per-account tool dialog (Filters,
 * Screener, Spam). Renders nothing when there's 0–1 account — there's nothing to
 * choose — so single-account users never see a redundant control.
 */

import type { EmailConnection } from '@/lib/api';

interface DialogAccountPickerProps {
  accounts: EmailConnection[];
  value: string | undefined;
  onChange: (accountId: string) => void;
}

export function DialogAccountPicker({ accounts, value, onChange }: DialogAccountPickerProps) {
  if (accounts.length <= 1) return null;
  return (
    <label className="block space-y-1">
      <span className="text-xs text-muted-foreground">Account</span>
      <select
        aria-label="Account"
        className="h-9 w-full rounded-md border bg-background px-2 text-sm"
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value)}
      >
        {accounts.map((a) => (
          <option key={a.accountId} value={a.accountId}>
            {a.emailAddress}
          </option>
        ))}
      </select>
    </label>
  );
}
